import { ComponentTypes } from './ComponentTypesList';
import { ISection } from './Section';

interface IBaseScreen {
  id: number;
  name: string;
  width: number;
  height: number;
  settings: unknown;
  created_at: string;
  modified_at: string;
  channel_screen_sequence: number;
  sections: ISection[];
  layoutScreenId?: number;
}

export interface IScreen extends IBaseScreen {
  config?: ISectionConfig;
}

export interface IScreenType extends IBaseScreen {
  config?: ISectionConfigType;
}

export enum DynamicSectionEvents {
  COD_COMPLETE = 'COD_COMPLETE',
  COD_ORDER_OPEN = 'COD_ORDER_OPEN',
  COD_ORDER_EXPAND = 'COD_ORDER_EXPAND',
  COD_THANK_YOU_OPEN = 'COD_THANK_YOU_OPEN',
  COD_THANK_YOU_CLOSE = 'COD_THANK_YOU_CLOSE',
  COD_CONFIRMATION_OPEN = 'COD_CONFIRMATION_OPEN',
  DY_SUGGESTIONS_OPEN = 'DY_SUGGESTIONS_OPEN',
  DY_SUGGESTIONS_CLOSE = 'DY_SUGGESTIONS_CLOSE',
  DY_RECOMMENDATIONS_UPDATE = 'DY_RECOMMENDATIONS_UPDATE',
  SECTION_TIMER = 'SECTION_TIMER',
  LAYOUT_TIMER = 'LAYOUT_TIMER',
  DEFAULT = 'DEFAULT',
}

export interface ISectionConfig {
  events?: DynamicEvents;
  initial?: string | any; // TODO: fix this later
  dynamicHighlight?: number;
  suggestedComponentTypes?: ComponentTypes[];
  duration?: number;
}

interface ISectionConfigType {
  journey?: ISectionJourney[];
  events: string[];
}

interface ISectionJourney {
  events: DynamicSectionEvents[];
  name: string;
}

interface EventData {
  style: string;
}

export type DynamicEvents = Record<DynamicSectionEvents | string, EventData>;
